


import React, { useEffect, useState } from 'react'

import { useSortable } from '@dnd-kit/sortable';
import { CSS } from '@dnd-kit/utilities'; 
import ListDetailView from './listDetailView';
import styles from './Style.module.scss';


export default function DraggableTagView(props) {
  const { attributes, listeners, setNodeRef, transform, transition } = useSortable({ id:props.option.id });
  const [isDragging, setIsDragging] = useState(false);
  const style = {
    transform: transform ?  CSS.Transform.toString(transform):undefined,
    transition: !isDragging ? 'none' : transition,
  };
  useEffect(() => {
    if (transform) {
      setIsDragging(true);
    } else {
      setIsDragging(false);
    }
  }, [transform]);
  return (
   

    <div ref={setNodeRef} style={style} 
    {...attributes} 
    {...listeners}
    
    >


      <ListDetailView
                key={props.option.id}
                
                index={props.index}
                option={props.option}
                onChange={props.onChange}
                onDelete={props.onDelete}
                integrationType={props.integrationType}
              />

              <div className={styles.line}/>
      </div>
  );
}






